// removed by extract-text-webpack-plugin
module.exports = {"default-editor":"default-editor","poster-title":"poster-title","medium-editor-element":"medium-editor-element","medium-editor-placeholder":"medium-editor-placeholder","edit-item":"edit-item","add-item":"add-item","add-text":"add-text","add-item-btn":"add-item-btn","icon-picture":"icon-picture","icon-plus":"icon-plus","icon-font":"icon-font","image":"image","edit-item-trash":"edit-item-trash"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Poster/EditPoster-archieve/DefaultEditor.scss
// module id = DaH7
// module chunks = 0